/**
 * @module FloatSidebar
 */
;(function FloatSidebar() {
    function floatSidebar(dom) {
        /**
         * // local object availability
         * @type {floatSidebar}
         * @private
         */
        var _this = this

        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            $(dom).on('click', "[data='float-sidebar-item']", function () {
                $(this).toggleClass('active')
                var currentActiveIndex = $(dom).find("[data='float-sidebar-item']").index($(this))
                var $filteredElementsArray = $(dom)
                    .find("[data='float-sidebar-item']")
                    .filter(function (index) {
                        return index != currentActiveIndex
                    })

                $filteredElementsArray.removeClass('active')
            })

            $('html').on('click', function (e) {
                if (!$(e.target).hasClass('float-sidebar-item')) {
                    $('.float-sidebar-item.active').removeClass('active')
                }
            })
        }

        /**
         * initialize call
         */
        _this.init()
    }

    // define the global scope
    if (!window.Creaton) {
        window.Creaton = {}
    }

    window.Creaton.floatSidebar = floatSidebar
})()

$(document).ready(function () {
    var $floatSidebar = $("[data='float-sidebar']")
    if ($floatSidebar.length) {
        new window.Creaton.floatSidebar($floatSidebar)
    }
})
